var React = require('react');

function PlayBlack (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"24","cy":"24","r":"24","fill":"black","key":0}),React.createElement("path",{"d":"M29.8667 24L21.0667 29.0806L21.0667 18.9193L29.8667 24Z","fill":"white","key":1})]);
}

PlayBlack.defaultProps = {"width":"80","height":"80","viewBox":"0 0 48 48","fill":"none"};

module.exports = PlayBlack;

PlayBlack.default = PlayBlack;
